import { render, staticRenderFns } from "./RefundForDiscount.vue?vue&type=template&id=f24ffef8&"
import script from "./RefundForDiscount.vue?vue&type=script&lang=js&"
export * from "./RefundForDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports